class ProductBar extends HTMLElement {
  connectedCallback() {
    this.section = this.closest(".shopify-section") || document;
    this.submit = this.section.querySelector(".product-info product-form-submit button");
    this.button = this.querySelector("[data-product-bar-submit]");
    this.retailers = this.querySelector("[data-product-bar-retailers]");
    this.controls = this.querySelectorAll("a, button");

    if (!this.submit || !this.button) {
      return;
    }

    this.button.addEventListener("click", () => this.submit.click());

    if (this.retailers) {
      this.retailers.addEventListener("click", this.scrollToRetailers.bind(this));
    }

    this.disabledObserver = new MutationObserver(this.syncDisabled.bind(this));
    this.disabledObserver.observe(this.submit, { attributes: true, attributeFilter: ["disabled"] });

    this.viewObserver = new IntersectionObserver(([entry]) => this.setVisible(!entry.isIntersecting));
    this.viewObserver.observe(this.submit);

    if (this.retailers) {
      this.onScroll = this.scheduleTone.bind(this);
      window.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onScroll);
    }

    this.syncDisabled();
  }

  disconnectedCallback() {
    this.disabledObserver?.disconnect();
    this.viewObserver?.disconnect();

    if (this.onScroll) {
      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onScroll);
    }
  }

  scheduleTone() {
    if (this.toneFrame || !this.classList.contains("state--visible")) {
      return;
    }

    this.toneFrame = requestAnimationFrame(() => {
      this.toneFrame = null;
      this.setTone();
    });
  }

  setTone() {
    const x = this.retailers.offsetLeft + this.retailers.offsetWidth / 2;
    const y = window.innerHeight - this.offsetHeight + this.retailers.offsetTop + this.retailers.offsetHeight / 2;
    const layers = document.elementsFromPoint(x, y);
    const over_media = layers.some((layer) => !this.contains(layer) && layer.matches("img, video, picture"));

    this.retailers.classList.toggle("button-2", !over_media);
    this.retailers.classList.toggle("button-3", over_media);
  }

  setVisible(visible) {
    this.classList.toggle("state--visible", visible);

    if (visible && this.retailers) {
      this.setTone();
    }

    this.setAttribute("aria-hidden", !visible);
    this.controls.forEach((control) => {
      control.tabIndex = visible ? 0 : -1;
    });
  }

  syncDisabled() {
    this.button.disabled = this.submit.disabled;
  }

  scrollToRetailers(event) {
    const target = document.getElementById("product-retailers");

    if (!target) {
      return;
    }

    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

customElements.define("product-bar", ProductBar);
